/**
 * DropsStatusPills
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import { Button } from '@/components/ui';
import type { DropStatusLabel } from '@/types/smswiser-drops';

export type DropsStatusFilter = 'all' | DropStatusLabel;

const STATUS_OPTIONS: { id: DropsStatusFilter; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'started', label: 'Started' },
  { id: 'pending', label: 'Pending' },
  { id: 'scheduled', label: 'Scheduled' },
  { id: 'completed', label: 'Completed' },
  { id: 'paused', label: 'Paused' },
  { id: 'stopped', label: 'Stopped' },
  { id: 'draft', label: 'Draft' },
];

interface DropsStatusPillsProps {
  value: DropsStatusFilter;
  onChange: (value: DropsStatusFilter) => void;
}

export const DropsStatusPills: FC<DropsStatusPillsProps> = ({ value, onChange }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {STATUS_OPTIONS.map((opt) => (
        <Button
          key={opt.id}
          size="sm"
          variant={value === opt.id ? 'default' : 'outline'}
          onClick={() => onChange(opt.id)}
        >
          {opt.label}
        </Button>
      ))}
    </div>
  );
};

export default DropsStatusPills;

